module.exports = __webpack_public_path__ + "7148df87b6f8c699879f41bb2fceebec.pdf";